import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InsuranceCoverageModel} from '../../../../../core/models/insurance-coverage.model';
import {FiltersService} from '../../../../services/filters.service';
import {MobileFiltersDialogComponent} from '../../offer-section/mobile-filters-dialog/mobile-filters-dialog.component';
import {
  FilterMessage,
  FiltersApplicationMode
} from '../../offer-section/offers-filters/offers-filter/offers-filter.model';
import {MatDialog} from '@angular/material';
import {FormConfig} from '../../../../models/form-config';
import {FieldType} from '../../../../models/field-type';
import {SectionBase} from '../../../../components/section/section-base';
import {PrimaryCoverageFilterCheckEvent} from '../../insurance-coverages-section/insurance-coverages-section.component';
import {isNestBank} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-offers-control-panel',
  templateUrl: './offers-control-panel.component.html',
  styleUrls: []
})
export class OffersControlPanelComponent extends SectionBase implements OnInit {

  @Input() offersAmount: number;
  @Output() viewChange: EventEmitter<OffersView> = new EventEmitter<OffersView>();
  readonly translationsContainer = 'OFFER_SECTION';
  openFiltersButtonIcon: string;
  showFiltersButtonIcon: string;
  showFiltersButtonIconChecked: string;
  config: OffersControlPanelConfig = new OffersControlPanelConfig();
  SectionFieldKey = OffersControlPanelFieldKey;
  tilesContentData: OffersViewTileContentData[];
  toggleFiltersButtonHidden: boolean = false;

  constructor(public filtersService: FiltersService,
              private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.initIcons();
    this.createConfig();
    this.createTilesContentData();
    this.initBean();
    this.buildForm();
    this.initControlsChanges();
  }

  onFilterUpdate(data: InsuranceCoverageModel): void {
    this.filtersService.updatePrimaryCoverageFilterState(data);
  }

  openFilters(): void {
    const mobileFiltersDialog = this.dialog.open(MobileFiltersDialogComponent, {
      panelClass: 'mobile-filters-panel',
      closeOnNavigation: false,
      autoFocus: false,
      data: {}
    });
    mobileFiltersDialog.afterOpened().subscribe(() => this.filtersService.changeMode(FiltersApplicationMode.ON_CONFIRMATION));
    mobileFiltersDialog.afterClosed().subscribe(() => this.filtersService.changeMode(FiltersApplicationMode.AUTOMATIC));
  }

  createConfig(): void {
    this.formConfig = this.config.createConfig();
  }

  initBean(): void {

  }

  initControlsChanges(): void {
    this.handleControlsState({
      controlName: OffersControlPanelFieldKey.OFFERS_VIEW, behaviour: value => {
        this.viewChange.emit(value);
        this.toggleFiltersButtonHidden = value === OffersView.TABLE
      }
    })
  }

  onCoverageCheckedUpdate(event: PrimaryCoverageFilterCheckEvent): void {
    this.filtersService.onCoverageCheckedUpdate(event);
  }

  private initIcons(): void {
    this.openFiltersButtonIcon = './assets/images/icons/open-offers-filters.svg';
    this.showFiltersButtonIcon = isNestBank() ? './assets/images/icons/offers-filters-black.svg' : './assets/images/icons/offers-filters-light.svg';
    this.showFiltersButtonIconChecked = isNestBank() ? './assets/images/icons/offers-filters-light.svg' : './assets/images/icons/offers-filters-dark.svg';
  }

  private createTilesContentData(): void {
    this.tilesContentData = [
      {
        caption: 'OFFERS_CONTROL_PANEL.OFFERS_VIEW.list',
        icon: isNestBank() ? './assets/images/icons/list-dark.svg' : './assets/images/icons/list-light.svg',
        iconChecked: isNestBank() ? './assets/images/icons/list-black.svg' : './assets/images/icons/list-dark.svg'
      },
      {
        caption: 'OFFERS_CONTROL_PANEL.OFFERS_VIEW.table',
        icon: isNestBank() ? './assets/images/icons/table-dark.svg' : './assets/images/icons/table-light.svg',
        iconChecked: isNestBank() ? './assets/images/icons/table-black.svg' : './assets/images/icons/table-dark.svg'
      }
    ]
  }

}

export enum OffersView {
  LIST = 'LIST',
  TABLE = 'TABLE',
}

export interface OffersViewTileContentData {
  caption: string;
  icon: string;
  iconChecked: string;
}

export class OffersControlPanelConfig {

  readonly TRANSLATIONS_CONTAINER = 'OFFERS_CONTROL_PANEL.OFFERS_VIEW';

  constructor() {

  }

  createConfig(): FormConfig {
    return {
      formKey: 'OFFERS_CONTROL_PANEL',
      fieldsConfig: [
        {
          fieldKey: OffersControlPanelFieldKey.OFFERS_VIEW,
          type: FieldType.RadioCheckboxTile,
          caption: `${this.TRANSLATIONS_CONTAINER}.caption`,
          validators: [],
          radioConfig: [
            {
              value: OffersView.LIST,
              label: `${this.TRANSLATIONS_CONTAINER}.list`
            },
            {
              value: OffersView.TABLE,
              label: `${this.TRANSLATIONS_CONTAINER}.table`
            }
          ],
          initialValue: OffersView.LIST,
          radioCheckboxTileConfig: {
            checkboxDisabled: true
          }
        }
      ]
    };
  }
}

export enum OffersControlPanelFieldKey {
  OFFERS_VIEW = 'OFFERS_VIEW',
}
